import {Component, OnInit, Renderer2, ChangeDetectorRef} from '@angular/core';
import { BaseGridEditLineComponent } from '../../shared/base-components/base-grid-editline.component';
import { GlobalsService } from '../../shared/services/globals.service';
import { InventoryService } from '../../shared/services/inventory.service';
import { SaveMode } from '../../shared/enums/SaveMode';
import { v_InventoryBus } from '../../shared/models/v_InventoryBus';
import { InventoryConsumablesBus } from '../../shared/models/InventoryConsumablesBus';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'cp-inventory-consumables',
    templateUrl: './inventory-consumables.component.html',
    styleUrls: ['./inventory-consumables.component.scss']
})
export class InventoryConsumablesComponent extends BaseGridEditLineComponent<InventoryConsumablesBus, null, InventoryService> {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: InventoryService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "InventoryConsumablesBus";
        this.appCode = "InventoryConsumables";
        this.inventorySvcField = "number";
        this.saveMode = SaveMode.all;

    }

    public showWarehouseTransfers = false;

    public showWindow() {
        this.showWarehouseTransfers = !this.showWarehouseTransfers;
    }

    setForm() {
        this.editForm.patchValue({
            inventoryConsumableId: this.selectedData.inventoryConsumableId,
            inventoryId: this._parentId,
            number: this.selectedData.number,
            inventoryDesc: this.selectedData.inventoryDesc,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            consumableId: this.selectedData.consumableId
        });
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'inventoryConsumableId': new UntypedFormControl(),
            'inventoryId': new UntypedFormControl(),
            'number': new UntypedFormControl(),
            'inventoryDesc': new UntypedFormControl(),
            'consumableId': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
        });

    }
}
